/** One allowlisted projection for public HTML, cards, stats and owner preview. */
export function projectPublicResume(data) {
  const settings = data.publicSettings || {};
  const selected = new Set(settings.raceIds || []);
  const races = (data.races || []).filter(r => settings.scope !== 'selected' || selected.has(r.id)).map(r => ({
    id: r.id, raceName: r.raceName || '', distance: r.distance ?? 0,
    time: r.time || null, type: r.type || 'road', elevation: r.elevation ?? null,
    date: r.date || null, isTimed: r.isTimed !== false,
    isHighlighted: !!r.isHighlighted, isPR: false, isPodium: !!r.isPodium,
    resultsLink: r.resultsLink || null, notes: settings.showNotes === false ? null : r.notes || null,
    location: settings.showLocations === false ? null : r.location || null,
    lat: settings.showLocations === false ? null : r.lat ?? null,
    lng: settings.showLocations === false ? null : r.lng ?? null,
    country: settings.showLocations === false ? null : r.country || null,
  }));
  return { name: data.name || '', subtitle: data.subtitle || '', profileImageUrl: data.profileImageUrl || null,
    templateId: data.templateId || 'classic', races, raceCount: races.length };
}
